import { BRAND, HERO } from "@/config/site";
import { goToForm } from "@/lib/prefill";

export const Hero = () => (
  <section id="home" className="relative min-h-[92vh] flex items-end lg:items-center overflow-hidden grain pt-16 lg:pt-[72px]" data-testid="hero-section">
    <img src="/images/hero.webp" alt={HERO.imageAlt} fetchPriority="high" className="absolute inset-0 h-full w-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-t from-forest-deep/90 via-forest-deep/55 to-forest-deep/30 lg:bg-gradient-to-r lg:from-forest-deep/90 lg:via-forest-deep/60 lg:to-transparent" />
    <div className="container-ph relative pt-32 pb-16 lg:py-40">
      <div className="max-w-2xl">
        <p className="eyebrow hero-in hero-in-1" data-testid="hero-eyebrow">{BRAND.name}</p>
        <p className="mt-2 text-sm text-ivory/80 tracking-wide hero-in hero-in-1" data-testid="hero-subtitle">{BRAND.subtitle}</p>
        <h1 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.05] text-ivory hero-in hero-in-2" data-testid="hero-title">{BRAND.claim}</h1>
        <p className="mt-6 max-w-xl text-base sm:text-lg text-ivory/85 leading-relaxed hero-in hero-in-3" data-testid="hero-text">{HERO.text}</p>
        <div className="mt-9 flex flex-col sm:flex-row gap-3 hero-in hero-in-4">
          <button className="btn-primary ring-1 ring-ivory/40" data-testid="hero-cta-immobile"
                  onClick={() => goToForm({ situazione: "Ho un immobile", obiettivi: ["Aprire"] })}>{HERO.cta1}</button>
          <button className="btn-light" data-testid="hero-cta-struttura"
                  onClick={() => goToForm({ situazione: "Ho già una struttura" })}>{HERO.cta2}</button>
        </div>
      </div>
    </div>
  </section>
);
